import { Injectable, signal } from '@angular/core';

import { CipError } from '@mobi/rwc-utils-azure-ng-jslib';

@Injectable({ providedIn: 'root' })
export class DefaultCipErrorHandler {
    readonly error = signal<CipError | undefined>(undefined);
    handleError = (cipError: CipError): void => {
        this.error.set(cipError);
    };
}
